import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    quoteSingle:
    {
      ACTION: 'QUOTE',
      ADULTS: '1',
      BUSINESS: '0',
      CHILDREN: 0,
      COVERTYPE: 'SINGLEG',
      CRUISE: '0',
      DESTINATION: '1',
      DISC: 'false',
      DUBDISCOUNT: '0',
      DATEFROM: '',
      DATETO: '',
      FAMILYDISCOUNT: '1',
      GUID: '',
      INFANTS: 0,
      OPTION: '',
      ORIGIN: '1',
      QUOTEID: '1',
      TESTVAR: '5',
      WINTERSPORT: '0',
      PREMIUM: ''
    },
    quoteAnnual:
    {
      ACTION: 'QUOTE',
      ADULTS: '1',
      BUSINESS: '0',
      CHILDREN: '0',
      COVERTYPE: 'ANNUALG',
      CRUISE: '0',
      DESTINATION: '3',
      DISC: 'false',
      DUBDISCOUNT: '0',
      DURATION: '12M',
      FAMILYDISCOUNT: '1',
      GUID: '',
      INFANTS: '0',
      OPTION: 'INSUK',
      ORIGIN: '1',
      QUOTEID: '1',
      TESTVAR: '5',
      WINTERSPORT: '1',
      PREMIUM: ''
    },
    quoteBackpacker:
    {
      ACTION: 'QUOTE',
      ADULTS: '1',
      BUSINESS: '0',
      CHILDREN: 0,
      COVERTYPE: 'BACKPACKER',
      CRUISE: '0',
      DESTINATION: '1',
      DISC: 'false',
      DUBDISCOUNT: '0',
      DATEFROM: '',
      DATETO: '',
      FAMILYDISCOUNT: '1',
      GUID: '',
      INFANTS: 0,
      OPTION: '',
      ORIGIN: '1',
      QUOTEID: '1',
      TESTVAR: '5',
      WINTERSPORT: '0',
      PREMIUM: ''
    },
    tripDetailsInfo: {
      residence: '',
      durationString: '',
      destination: '',
      numberPeopleString: '',
      totalNumberOfPeople: '',
      totalAdults: '',
      quoteType: 'SINGLEG',
      bookingNumber: '',
      fromDate: '',
      toDate: '',
      departureDate: '',
      quoteInfoSingle: {},
      quoteInfoAnnual: {},
      quoteInfoBackpacker: {},
      peopleAges: [],
      passengers: {},
      // create form{} obj below if fields start adding up
      email: ''
    },
    Step1: {
      residence: '',
      quoteType: '',
      destination: '',
      dateFrom: '',
      dateTo: '',
      peopleAges: []
    },
    isBackpacker : window.location.href.includes('travel-academy') ? true : false,
    fromDateRaw : new Date(),
    toDateRaw : new Date(),

  },
  mutations: {
    updateField,
    // QUOTE
    SET_IS_BACKPACKER(state, payload) {
      state.isBackpacker = payload
    },
    SET_FROM_DATE_RAW(state, payload) {
      state.fromDateRaw = payload
    },
    SET_TO_DATE_RAW(state, payload) {
      state.toDateRaw = payload
    },
    SET_QUOTE_SINGLE(state, payload) {
      state.quoteSingle = payload
    },
    SET_QUOTE_ANNUAL(state, payload) {
      state.quoteAnnual = payload
    },
    SET_QUOTE_BACKPACKER(state, payload) {
      state.quoteBackpacker = payload
    },
    SET_QUOTE_GUID(state, payload) {
      state.quoteSingle.GUID = payload
      state.quoteAnnual.GUID = payload
      state.quoteBackpacker.GUID = payload
    },
    SET_QUOTE_OPTION(state, payload) {
      state.quoteSingle.OPTION = payload
      state.quoteAnnual.OPTION = payload
      state.quoteBackpacker.OPTION = payload
    },
    SET_PREMIUM_SINGLE(state, payload) {
      state.quoteSingle.PREMIUM = payload
    },
    SET_PREMIUM_ANNUAL(state, payload) {
      state.quoteAnnual.PREMIUM = payload
    },
    SET_DATE_FROM(state, payload) {
      state.quoteSingle.DATEFROM = payload
      state.quoteBackpacker.DATEFROM = payload
    },
    SET_PREMIUM_BACKPACKER(state, payload) {
      state.quoteBackpacker.PREMIUM = payload
    },
    SET_DATE_TO(state, payload) {
      state.quoteSingle.DATETO = payload
      state.quoteBackpacker.DATETO = payload
    },
    SET_ADULTS(state, payload) {
      state.quoteSingle.ADULTS = payload
      state.quoteAnnual.ADULTS = payload
      state.quoteBackpacker.ADULTS = payload
    },
    SET_CHILDREN(state, payload) {
      state.quoteSingle.CHILDREN = payload
      state.quoteAnnual.CHILDREN = payload
      state.quoteBackpacker.CHILDREN = payload
    },
    SET_INFANTS(state, payload) {
      state.quoteSingle.INFANTS = payload
      state.quoteAnnual.INFANTS = payload
      state.quoteBackpacker.INFANTS = payload
    },
    SET_QUOTE_AGES(state, payload) {
      state.quoteSingle['AGE' + payload.key] = payload.value
      state.quoteAnnual['AGE' + payload.key] = payload.value
      state.quoteBackpacker['AGE' + payload.key] = payload.value
    },
    SET_QUOTE_EDUS(state, payload) {
      state.quoteSingle['EDU' + payload.key] = payload.value ? payload.value : ""
      state.quoteAnnual['EDU' + payload.key] = payload.value ? payload.value : ""
      state.quoteBackpacker['EDU' + payload.key] = payload.value ? payload.value : ""
    },

    // TRIP D
    SET_TRIP_DETAILS_INFO(state, payload) {
      state.tripDetailsInfo = payload
    },
    SET_QUOTE_TYPE(state, payload) {
      state.tripDetailsInfo.quoteType = payload
    },
    SET_QUOTE_INFO_SINGLE(state, payload) {
      state.tripDetailsInfo.quoteInfoSingle = payload.response
    },
    SET_QUOTE_INFO_ANNUAL(state, payload) {
      state.tripDetailsInfo.quoteInfoAnnual = payload.response
    },
    SET_QUOTE_INFO_BACKPACKER(state, payload) {
      state.tripDetailsInfo.quoteInfoBackpacker = payload.response
    },
    SET_PEOPLE_AGES(state, payload) {
      state.tripDetailsInfo.peopleAges = payload.peopleAges
    },
    SET_DEPDATE(state, payload) {
      state.tripDetailsInfo.departureDate = payload
    },
    SET_BOOKING_NUM(state, payload) {
      state.tripDetailsInfo.bookingNumber = payload
    },
    SET_EMAIL(state, payload) {
      state.tripDetailsInfo.email = payload
    },
    SET_PASSENGERS(state, payload) {
      state.tripDetailsInfo.passengers = payload.passengers
    },

    SET_STEP1(state, payload) {
      state.Step1 = payload
    }
  },

  actions: {
    // QUOTES
    updateIsBackpacker({ commit },payload) {
      commit('SET_IS_BACKPACKER', payload)
    },
    updateFromDateRaw({ commit },payload) {
      commit('SET_FROM_DATE_RAW', payload)
    },
    updateToDateRaw({ commit },payload) {
      commit('SET_TO_DATE_RAW', payload)
    },
    updateQuoteSingle({ commit }, payload) {
      commit('SET_QUOTE_SINGLE', payload)
    },
    updateQuoteAnnual({ commit }, payload) {
      commit('SET_QUOTE_ANNUAL', payload)
    },
    updateQuoteBackpacker({commit}, payload) {
      commit('SET_QUOTE_BACKPACKER', payload)
    },
    updateGUID({ commit }, payload) {
      commit('SET_QUOTE_GUID', payload)
    },
    updateOption({ commit }, payload) {
      commit('SET_QUOTE_OPTION', payload)
    },
    updatePremiumSingle({ commit }, payload) {
      commit('SET_PREMIUM_SINGLE', payload)
    },
    updatePremiumAnnual({ commit }, payload) {
      commit('SET_PREMIUM_ANNUAL', payload)
    },
    updatePremiumBackpacker({ commit }, payload) {
      commit('SET_PREMIUM_BACKPACKER', payload)
    },
    updateDateFrom({ commit }, payload) {
      commit('SET_DATE_FROM', payload)
    },
    updateDateTo({ commit }, payload) {
      commit('SET_DATE_TO', payload)
    },
    updateAdults({ commit }, payload) {
      commit('SET_ADULTS', payload)
    },
    updateChildren({ commit }, payload) {
      commit('SET_CHILDREN', payload)
    },
    updateInfants({ commit }, payload) {
      commit('SET_INFANTS', payload)
    },
    addAgesToQuotes({ commit }, payload) {
      for (let i = 0; i < 10; i++) {
        commit('SET_QUOTE_AGES', { key: i + 1, value: payload.peopleAges[i] ? payload.peopleAges[i].AGE : "" })
      }
    },
    addEduToQuotes({ commit }, payload) {
      for (let i = 0; i < 10; i++) {
        commit('SET_QUOTE_EDUS', { key: i + 1, value: payload.peopleAges[i] ? payload.peopleAges[i].EDU : "" })
      }
    },
    // TRIP D
    updateTripDetailsInfo({ commit }, payload) {
      commit('SET_TRIP_DETAILS_INFO', payload)
    },
    updateQuoteType({ commit }, payload) {
      commit('SET_QUOTE_TYPE', payload)
    },
    fetchQuoteInfoSingle({ commit }, payload) {
      commit('SET_QUOTE_INFO_SINGLE', payload)
    },
    fetchQuoteInfoAnnual({ commit }, payload) {
      commit('SET_QUOTE_INFO_ANNUAL', payload)
    },
    fetchQuoteInfoBackpacker({ commit }, payload) {
      commit('SET_QUOTE_INFO_BACKPACKER', payload)
    },
    updatePeopleAges({ commit }, payload) {
      commit('SET_PEOPLE_AGES', payload)
    },
    updateDepartureDate({ commit }, payload) {
      commit('SET_DEPDATE', payload)
    },
    updateBookingNum({ commit }, payload) {
      commit('SET_BOOKING_NUM', payload)
    },
    updateEmail({ commit }, payload) {
      commit('SET_EMAIL', payload)
    },
    updatePassengers({ commit }, payload) {
      commit('SET_PASSENGERS', payload)
    },

    updateStep1({ commit }, payload) {
      commit('SET_STEP1', payload)
    }
  },
  getters: {
    getField,
    getFromDateFormatted(state) {
      return state.getFromDateFormatted
    },
    getToDateFormatted(state) {
      return state.getToDateFormatted
    },
    getFromDateRaw(state) {
      return state.getFromDateRaw
    },
    getToDateRaw(state) {
      return state.getToDateRaw
    },
    getQuoteSingle(state) {
      return state.quoteSingle
    },
    getQuoteAnnual(state) {
      return state.quoteAnnual
    },
    getQuoteBackpacker(state) {
      return state.quoteBackpacker
    },
    getTripDetailsInfo(state) {
      return state.tripDetailsInfo
    },
    getStep1(state) {
      return state.Step1
    }

  }
})
